import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "text", "spinner"]

  download(e) {
    e.preventDefault()
    const button = e.currentTarget

    this.showLoading()

    const form = this.findVisibleForm()
    const url = new URL(button.href, window.location.origin)

    if (form) {
      const selectionController = this.application.getControllerForElementAndIdentifier(
        form, 'table-selection'
      )

      if (selectionController) {
        const selectedIds = selectionController.getSelectedIds()

        if (selectedIds.length > 0) {
          url.searchParams.set('selected_ids', selectedIds.join(','))
        } else {
          new FormData(form).forEach((value, key) => {
            url.searchParams.append(key, value)
          })
        }
      } else {
        new FormData(form).forEach((value, key) => {
          url.searchParams.append(key, value)
        })
      }
    }

    fetch(url.toString())
      .then(response => {
        const disposition = response.headers.get('Content-Disposition') || ''
        const matches = disposition.match(/filename="([^"]+)"/)
        const filename = matches ? matches[1] : 'export_data.xlsx'
        return response.blob().then(blob => ({ blob, filename }))
      })
      .then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
        button.blur()
      })
      .catch(error => {
        console.error('Export failed:', error)
        alert('Export failed. Please try again.')
      })
      .finally(() => {
        // Hide loading state
        this.hideLoading()
      })
  }

  showLoading() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.add('disabled')
      this.buttonTarget.style.pointerEvents = 'none'
    }
    if (this.hasTextTarget) {
      this.textTarget.textContent = 'Exporting...'
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove('d-none')
    }
  }

  hideLoading() {
    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove('disabled')
      this.buttonTarget.style.pointerEvents = ''
    }
    if (this.hasTextTarget) {
      this.textTarget.textContent = 'Export'
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add('d-none')
    }
  }

  findVisibleForm() {
    const forms = document.querySelectorAll('form[data-controller*="table-selection"]')

    for (const form of forms) {
      if (form.offsetParent !== null) {
        return form
      }
    }

    if (forms.length > 0) {
      return forms[0]
    }

    return null
  }
}
